(function() {
    'use strict';

    angular
        .module('telestatApp')
        .filter('phone', function () {
            return function (phoneNumber) {
                // TODO Константа через интернационализацию
                if (phoneNumber == 0) return "[скрытый номер]";
                var phoneStr = phoneNumber.toString();
                if (phoneStr.length > 8) {
                    var country_code = phoneStr.substr(0,1);
                    var region_code = phoneStr.substr(1,3);
                    var st_code  = phoneStr.substr(4,3);
                    var octet1 = phoneStr.substr(7,2);
                    var octet2 = phoneStr.substr(9);
                    return "+" + country_code + "(" + region_code + ")" + st_code + "‑" + octet1 + "‑" + octet2;
                } else return "+" + phoneStr;
            };
        });
})();
